import Blockly from "blockly";
import Schema from "../schema";
import { hexToRGBA } from "./utils";

export const menu = {
  name: (<div className="text"><u>V</u>isual Effects</div>),
  trigger: 'v',
  children: {
    'player_animate': {
      name: (<div className="text"><u>A</u>nimate player</div>),
      trigger: 'a',
    },
    'player_costume': {
      name: (<div className="text"><u>C</u>hange player costume</div>),
      trigger: 'c',
    },
    'player_fart': {
      name: (<div className="text"><u>F</u>art!</div>),
      trigger: 'f',
    },
    'player_fart_color': {
      name: (<div className="text"><u>F</u>art in color!</div>),
      trigger: 'f',
    },
  }
}

/* ****************************************************************************************************************
 * Animate
 ******************************************************************************************************************/
Blockly.Blocks['player_animate'] = {
  init: function () {
    this.appendDummyInput('animate')
      .appendField('Animate player with')
      .appendField(
        new Blockly.FieldDropdown(
          [
            ['Happy', 'happy'],
            ['Sad', 'sad'],
            ['Enter Pit', 'pitfallin'],
            ['Exit Pit', 'pitfallout'],
            ['Teleport In', 'teleportin'],
            ['Teleport Out', 'teleportout'],
            ['Enter Trapdoor', 'trapdoor'],
            ['Pog (requires Pog for Good Items mod installed)', 'pog'],
            ['Specialist Dance (requires Specialist Dance for Good Items mod installed)', 'specialistdance'],
          ]
        ),
        'Animation'
      );
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Animate the player using the specified animation.');
    this.setHelpUrl('');
  }
};

Blockly.JSON['player_animate'] = (block) => {
  let animation = block.getFieldValue('Animation');

  return {
    action: 'player_animate',
    params: {
      animation
    }
  };
};

Schema.registerAction('player_animate', {
  "if": {
    "properties": {
      "action": {
        "const": "player_animate"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "animation": {
            "enum": [
              "happy",
              "sad",
              "pitfallin",
              "pitfallout",
              "teleportin",
              "teleportout",
              "trapdoor",
              "pog",
              "specialistdance",
            ]
          },
        },
        "required": [
          "animation"
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ],
  }
});

/* ****************************************************************************************************************
 * Change Costume
 ******************************************************************************************************************/
Blockly.Blocks['player_costume'] = {
  init: function () {
    let shadow = this.workspace.newBlock('data_costumes');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['costume'])
      .appendField('Set players costume to')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Dresses the player up in the specified costume.');
    this.setHelpUrl('');
  }
};

Blockly.JSON['player_costume'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'player_costume',
      params
    }
  } else {
    return {
      action: 'player_costume',
      params: {
        entity_id: -1
      }
    }
  }
};

Schema.registerAction('player_costume', {
  "if": {
    "properties": {
      "action": {
        "const": "player_costume"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "costume"
            ]
          },
          "from_param": {
            "type": "string"
          },
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Fart
 ******************************************************************************************************************/
Blockly.Blocks['player_fart'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Fart!')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Makes the player fart!')
  }
}

Blockly.JSON['player_fart'] = (block) => {
  return {
    action: 'player_fart',
  }
}
/*
Schema.registerAction('player_fart', {
  "if": {
    "properties": {
      "action": {
        "const": "player_fart"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});
*/

/* ****************************************************************************************************************
 * Fart in colors
 ******************************************************************************************************************/
Blockly.Blocks['player_fart_color'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Fart using the specified color')
      .appendField(
        new Blockly.FieldColour(),
        'Color'
      )
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Farts in the specified color.')
  }
}

Blockly.JSON['player_fart_color'] = (block) => {
  const color = hexToRGBA(block.getFieldValue('Color'));

  return {
    action: 'player_fart',
    params: {
      ...color
    }
  }
}

Schema.registerAction('player_fart', {
  "if": {
    "properties": {
      "action": {
        "const": "player_fart"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "r": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "g": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "b": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "a": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
        },
        "additionalProperties": false
      }
    },
  }
});

